import React from 'react';
import { Form, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

import EstaSeguro from '../../../components/funcionales/estaseguro'

const ListaAgno = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="agno" id="miLista" value={permiteUpdate?argsDocum.agno:idLista.agno} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option>2021</option>
        <option>2022</option>
        <option>2023</option>
        <option>2024</option>
        <option>2025</option>
        <option>2026</option>
        <option>2027</option>
        <option>2028</option>
        <option>2029</option>
        <option>2030</option>
        <option>2031</option>
        <option>2032</option>
        <option>2033</option>
        <option>2034</option>
        <option>2035</option>
        <option>2036</option>
        <option>2037</option>
        <option>2038</option>  
        <option>2039</option>
        <option>2040</option>      
      </select>
    </div>
  )
};
const ListaMes = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="mes" id="miLista1" value={permiteUpdate?argsDocum.mes:idLista.mes} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option>Enero</option>
        <option>Febrero</option>
        <option>Marzo</option>
        <option>Abril</option>
        <option>Mayo</option>
        <option>Junio</option>
        <option>Julio</option>
        <option>Agosto</option>
        <option>Septiembre</option>
        <option>Octubre</option>
        <option>Noviembre</option>
        <option>Diciembre</option>
      </select>
    </div>
  )
};
const ListaGrupo = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="grupo" id="miLista3" value={permiteUpdate?argsDocum.grupo:idLista.grupo?idLista.grupo:'Sin grupo'} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option>Grupo 1</option>
        <option>Grupo 2</option>
        <option>Grupo 3</option>
        <option>Grupo 4</option>
        <option>Grupo 5</option>
        <option>Redes</option>
        <option>Administrativo</option>
        <option>Sin grupo</option>
      </select>
    </div>
  )
};
const DetalleNivel2 = props => {
  return (
    <option dato1={props.elemento.cedula} dato2={props.elemento.ciudad} dato3={props.elemento.email} dato4={props.elemento.telefono} value={props.elemento.nombreUsuario}>{props.elemento.nombreUsuario}</option>
  )
};
const ListaOpe = ({idLista, argsDocum, permiteUpdate, handleChange, list}) => {
  const Nivel2Detalle = list.map((elemento, _id) => <DetalleNivel2 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="nombreUsuario" id="miLista2" value={permiteUpdate?argsDocum.nombreUsuario:idLista.nombreUsuario} onChange={(ev)=>handleChange(ev, argsDocum)}>
        {Nivel2Detalle}
      </select>
    </div>
  )
};
class VerMeta2 extends React.Component {
  state={
    argsDocum: {
      tipoMeta: this.props.idLista.tipoMeta,
      agno: this.props.idLista.agno,
      mes: this.props.idLista.mes,
      valor: this.props.idLista.valor,
      meta: this.props.idLista.meta?this.props.idLista.meta:0,
      grupo: this.props.idLista.grupo?this.props.idLista.grupo:'Sin grupo',
      valorReal: this.props.idLista.valorReal,
      metaAgno: this.props.idLista.metaAgno?this.props.idLista.metaAgno:0,
      metaAcumAgno: this.props.idLista.metaAcumAgno?this.props.idLista.metaAcumAgno:0,
      nombreUsuario: this.props.idLista.nombreUsuario?this.props.idLista.nombreUsuario:"",
      cedula: this.props.idLista.cedula?this.props.idLista.cedula:"",
      estado: this.props.idLista.estado?this.props.idLista.estado:"",
      _id: this.props.idLista._id
    },
    confirmaAct: false,
    open: false
  }

  // handleChange = (ev) => {
  //   if (this.props.permiteUpdate){
  //     this.setState({confirmaAct: false})
  //     if(ev.target.name !== "abrevUnidad"){
  //       const argsDocum = this.state.argsDocum
  //       if(ev.target.name === "tipoUnidad"){
  //         let miLista = document.getElementById("miLista");
  //         argsDocum['tipoUnidad'] = miLista.options[miLista.selectedIndex].text
  //       }else{
  //         argsDocum[ev.target.name] = ev.target.value
  //       }
  //       this.setState({argsDocum});
  //     } 
  //   }
  // }

  handleChange = (ev) => {
    if (this.props.permiteUpdate){
        this.setState({confirmaAct: false})
        const argsDocum = this.state.argsDocum
        if(ev.target.name === "agno"){
          let miLista = document.getElementById("miLista");
          argsDocum['agno'] = miLista.options[miLista.selectedIndex].text
          }else{
            if(ev.target.name === "mes"){
              let miLista = document.getElementById("miLista1");
              argsDocum['mes'] = miLista.options[miLista.selectedIndex].text
              }else{
                argsDocum[ev.target.name] = ev.target.value
            }        
            if(this.props.idLista.tipoMeta!=='Utilidad' && ev.target.name === "nombreUsuario"){
              let miLista = document.getElementById("miLista2");
              argsDocum['cedula'] = miLista.options[miLista.selectedIndex].attributes[0].value
              argsDocum['nombreUsuario'] = miLista.options[miLista.selectedIndex].attributes[1].value
            }else{
              if(this.props.idLista.tipoMeta!=='Utilidad' && ev.target.name === "grupo"){
                let miLista = document.getElementById("miLista3");
                argsDocum['grupo'] = miLista.options[miLista.selectedIndex].text
              }else{
                argsDocum[ev.target.name] = ev.target.value
              }
            }        
          }
        this.setState({argsDocum});
    }
  }
  
  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  render(){
    const {argsDocum, confirmaAct, open} = this.state;
    // let descrMaterialAnt = this.props.idLista.descrMaterial
    // let codMaterialAnt = this.props.idLista.codMaterial
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large hand point down yellow icon"></i>
          Metas
        </button>
        <div style={this.props.styles.box}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsDocum):()=>{}}>
            <div className="ui one column stackable grid">
              <div className="row container">
                <div className="column" width="100%"><Form.Field>
                  <label style={this.props.styles.label}>Tipo de meta</label>
                    <Form.Input autoComplete="off" name="tipoMeta" id="tipoMeta" value={argsDocum.tipoMeta} icon={!this.props.errors.length?null: _find(this.props.errors, {path:'tipoMeta'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Año</label>
                    <ListaAgno styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Mes</label>
                    <ListaMes styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                  {argsDocum.tipoMeta!=='Utilidad' &&
                    <Form.Field>
                      <label style={this.props.styles.label}>Responsable</label>
                      <ListaOpe styles={this.props.styles} list={this.props.list} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                    </Form.Field>
                  }
                  {argsDocum.tipoMeta!=='Utilidad' &&
                    <Form.Field>
                      <label style={this.props.styles.label}>Grupo</label>
                      <ListaGrupo styles={this.props.styles} list={this.props.list} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                    </Form.Field>
                  }
                  {argsDocum.tipoMeta==='Comercial' &&
                    <Form.Field>
                      <label style={this.props.styles.label}>Base para comisión</label>
                      <input type='number' step="1" min="0" autoComplete="off" name="valor" id="valor" value={this.props.permiteUpdate?argsDocum.valor:this.props.idLista.valor} placeholder='Valor' onChange={this.handleChange}/>
                    </Form.Field>
                  }
                  <Form.Field>
                    <label style={this.props.styles.label}>Meta mes</label>
                    <input type='number' step="1" min="0" autoComplete="off" name="meta" id="meta" value={this.props.permiteUpdate?argsDocum.meta:this.props.idLista.meta} placeholder='Meta' onChange={this.handleChange}/>
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Meta año</label>
                    <input type='number' step="1" min="0" autoComplete="off" name="metaAgno" id="metaAgno" value={this.props.permiteUpdate?argsDocum.metaAgno:this.props.idLista.metaAgno} placeholder='Meta año' onChange={this.handleChange}/>
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Meta año acumulada</label>
                    <input type='number' step="1" min="0" autoComplete="off" name="metaAcumAgno" id="metaAcumAgno" value={this.props.permiteUpdate?argsDocum.metaAcumAgno:this.props.idLista.metaAcumAgno} placeholder='Meta año acum.' onChange={this.handleChange}/>
                  </Form.Field>
                  <EstaSeguro permiteUpdate={this.props.permiteUpdate} permiteDelete={this.props.permiteDelete} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                </div>
                {
                  this.props.errors.length?<Message negative header="Los siguientes errores:"
                  list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }

              </div>
            </div>
          </Form>
        </div>
      </div>
    )
  }
}

export default VerMeta2
